import IntegrationIndexPage from "../pages/integration/IntegrationIndexPage.vue";
import IntegrationEditPage from "../pages/integration/IntegrationEditPage.vue";
import IntegrationSidebarComponent from "../pages/integration/IntegrationSidebarComponent.vue";
import MainInformationCard from "../pages/integration/sidebarCards/MainInformationCard.vue";
import ProductsCard from "../pages/integration/sidebarCards/ProductsCard.vue";
import IntegrationProductCopyExportLink from "../pages/integration/sidebarCards/CopyLinkCard.vue";
import OrdersCard from "../pages/integration/sidebarCards/OrdersCard.vue";
import CreateIntegrationPage from "../pages/integration/IntegrationCreatePage.vue"
import ProductsImportsTable from "../pages/integration/sidebarCards/ProductsImportsTableCard.vue";
import CategoriesCard from "../pages/integration/sidebarCards/CategoriesCard.vue";
import CreateCategoryPage from "../pages/integration/sidebarCards/category/create/CreateCategoryPage.vue";
import EditCategoryCard from "../pages/integration/sidebarCards/category/edit/EditCategoryPage.vue";
import EditProduct from "../pages/integration/sidebarCards/products/edit/EditProductCard.vue";
import EditOrderCard from "../pages/integration/sidebarCards/EditOrderCard.vue";
import EditIntegrationFilterCard from "../pages/integration/sidebarCards/EditFilterCard.vue";
import EditIntegrationFilterItemCard from "../pages/integration/sidebarCards/EditFilterItemCard.vue";
import CreateIntegrationFilterCard from "../pages/integration/sidebarCards/CreateFilterCard.vue";
import CreateIntegrationFilterItemCard from "../pages/integration/sidebarCards/CreateFilterItemCard.vue";
import IntegrationProductsTable from "../pages/integration/sidebarCards/products/index/ProductsListPage.vue";
import OrdersTable from "../pages/integration/sidebarCards/orders/index/IntegrationOrdersListPage.vue";
import IntegrationCustomFieldsSettings from "../pages/integration/sidebarCards/IntegrationCustomFieldsSettings.vue";
import IntegrationStatusMatrix from "../pages/integration/sidebarCards/IntegrationStatusMatrix.vue";
import CreateProduct from "../pages/integration/sidebarCards/CreateProductCard.vue";
import TagsCard from "../pages/integration/sidebarCards/TagsCard.vue";
import AiProcessesListPage from "../pages/integration/aiProcess/AiProcessesListPage.vue";
import AiProcessEditPage from "../pages/integration/aiProcess/AiProcessEditPage.vue";
import AiProcessTaskEditPage from "../pages/integration/aiProcess/AiProcessTaskEditPage.vue";
import CreateTagsCard from "../pages/integration/sidebarCards/CreateTagsCard.vue";
import EditTagsCard from "../pages/integration/sidebarCards/EditTagsCard.vue";
import CompareIntegrationsPage from "../pages/integration/compare/CompareIntegrationsPage.vue";
import CopyGroupProductsPage from "../pages/integration/sidebarCards/copyGroupProducts/CopyGroupProductsPage.vue";
import i18n from '../i18n';
import store from '../store/index';

const basePath = "/app/projects/:projectUuid/pim/channels"

const integrationsRoutes = [
    {
        path: basePath,
        name: 'IndexIntegrationsPage',     
        component: IntegrationIndexPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexIntegrationsPage") }
                ]
            }
        },
    },
    {
        name: 'CompareIntegrationsPage',
        path: `${basePath}/compare`,
        component: CompareIntegrationsPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexIntegrationsPage"), linkName: 'IndexIntegrationsPage' },
                    { name: i18n.global.t("pages.CompareIntegrationsPage") }
                ]
            }
        },
    },
    {
        path: `${basePath}/:integrationUuid`,
        name: 'EditIntegration',
        components: {
            default: IntegrationEditPage,
            sidebar: IntegrationSidebarComponent,
        },
        redirect: { name: 'MainInformation' },
        async beforeEnter(to) {
            try {
                await store.dispatch('route/fetchIntegration', {
                    projectUuid: to.params.projectUuid,
                    integrationUuid: to.params.integrationUuid,
                });
            } catch (error) {
                const status = error?.response?.status;

                if (status === 404) {
                    return { name: 'NotFoundPage' };
                }

                throw error;
            }
        },
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexIntegrationsPage"), linkName: 'IndexIntegrationsPage' },
                    { name: store.state.route.integration?.name, linkName: 'MainInformation' },
                ]
            }
        },
        children: [
            {
                name: 'MainInformation',
                path: 'edit',
                component: MainInformationCard,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.MainInformation") }
                        ]
                    }
                },
            },
            {
                name: 'IntegrationProductsTable',
                path: 'products/all',
                component: IntegrationProductsTable,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.ProductsTable") }
                        ]
                    }
                },
            },
            {
                name: 'ProductsSettings',
                path: 'products/settings',
                component: ProductsCard,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.ProductsSettings") }
                        ]
                    }
                },
            },
            {
                name: "IntegrationProductCopyExportLink",
                path: 'products/export',
                component: IntegrationProductCopyExportLink,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.IntegrationProductCopyExportLink") }
                        ]
                    }
                }
            },
            {
                name: 'IntegrationOrdersTable',
                path: 'orders/all',
                component: OrdersTable,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrdersTable") },
                            { name: i18n.global.t("pages.AllIntegrationOrdersTable") }
                        ]
                    }
                }
            },
            {
                name: 'EditOrderCard',
                path: 'orders/:orderUuid/edit',
                component: EditOrderCard,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrdersTable") },
                            { name: i18n.global.t("pages.EditOrderCard") }
                        ]
                    }
                }
            },
            {
                name: 'OrdersSettings',
                path: 'orders/settings',
                component: OrdersCard,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.OrdersTable") },
                            { name: i18n.global.t("pages.OrdersSettings") }
                        ]
                    }
                },
            },
            {
                name: 'ProductsImports',
                path: 'products/imports',
                component: ProductsImportsTable,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.ProductsImports") }
                        ]
                    }
                },
            },
            {
                name: 'CategoriesCard',
                path: 'categories',
                component: CategoriesCard,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.CategoriesCard") }
                        ]
                    }
                }
            },
            {
                name: 'TagsCard',
                path: 'tags',
                component: TagsCard,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.TagsCard") }
                        ]
                    }
                }
            },
            {
                name: 'CreateTagsCard',
                path: 'tags/create',
                component: CreateTagsCard,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.TagsCard"), linkName: 'TagsCard' },
                            { name: i18n.global.t("pages.CreateTagsCard") }
                        ]
                    }
                }
            },
            {
                name: 'AiProcessesListPage',
                path: 'catalog/ai-processes',
                component: AiProcessesListPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.AiProcessesListPage") }
                        ]
                    }
                }
            },
            {
                name: 'AiProcessEditPage',
                path: 'catalog/ai-processes/:aiProcessUuid',
                component: AiProcessEditPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.AiProcessesListPage"), linkName: 'AiProcessesListPage' },
                            { name: i18n.global.t("pages.AiProcessEditPage") }
                        ]
                    }
                }
            },
            {
                name: 'AiProcessTaskEditPage',
                path: 'catalog/ai-processes/:aiProcessUuid/tasks/:aiProcessTaskUuid',
                component: AiProcessTaskEditPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.AiProcessesListPage"), linkName: 'AiProcessesListPage' },
                            { name: i18n.global.t("pages.AiProcessEditPage"), linkName: 'AiProcessEditPage' },
                            { name: i18n.global.t("pages.AiProcessTaskEditPage") }
                        ]
                    }
                }
            },
            {
                name: 'EditTagsCard',
                path: 'tags/:integrationProductTagUuid/edit',
                component: EditTagsCard,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.TagsCard"), linkName: 'TagsCard' },
                            { name: i18n.global.t("pages.EditTagsCard") }
                        ]
                    }
                }
            },
            {
                name: 'CreateCategoryPage',
                path: 'categories/create',
                component: CreateCategoryPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.CategoriesCard") },
                            { name: i18n.global.t("pages.CreateCategoryPage") }
                        ]
                    }
                }
            },
            {
                name: 'EditCategoryCard',
                path: 'categories/:categoryUuid/edit',
                component: EditCategoryCard,
                props: true,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.CategoriesCard") },
                            { name: i18n.global.t("pages.EditCategoryCard") }
                        ]
                    }
                }
            },
            {
                name: 'Product',
                path: 'products/:integrationProductUuid/edit',
                component: EditProduct,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.ProductsTable") },
                            { name: i18n.global.t("pages.Product") }
                        ]
                    }
                }
            },
            {
                name: 'CreateProductCard',
                path: 'products/create',
                component: CreateProduct,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.ProductsTable"), linkName: 'IntegrationProductsTable' },
                            { name: i18n.global.t("pages.CreateProduct") }
                        ]
                    }
                }
            },
            {
                name: 'EditIntegrationFilterCard',
                path: 'categories/:categoryUuid/edit/filters/:filterUuid',
                component: EditIntegrationFilterCard,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.CategoriesCard") },
                            { name: i18n.global.t("pages.EditCategoryCard") },
                            { name: i18n.global.t("pages.EditIntegrationFilterCard") }
                        ]
                    }
                }
            },
            {
                name: 'EditIntegrationFilterItemCard',
                path: 'categories/:categoryUuid/edit/filters/:filterUuid/filter-items/:filterItemUuid',
                component: EditIntegrationFilterItemCard,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.CategoriesCard") },
                            { name: i18n.global.t("pages.EditCategoryCard") },
                            { name: i18n.global.t("pages.EditIntegrationFilterCard") },
                            { name: i18n.global.t("pages.EditIntegrationFilterItemCard") }
                        ]
                    }
                }
            },
            {
                name: 'CreateIntegrationFilterCard',
                path: 'categories/:categoryUuid/edit/filters/create',
                component: CreateIntegrationFilterCard,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.CategoriesCard") },
                            { name: i18n.global.t("pages.EditCategoryCard") },
                            { name: i18n.global.t("pages.CreateIntegrationFilterCard") }
                        ]
                    }
                }
            },
            {
                name: 'CreateIntegrationFilterItemCard',
                path: 'categories/:categoryUuid/edit/filters/:filterUuid/filter-items/create',
                component: CreateIntegrationFilterItemCard,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.CategoriesCard") },
                            { name: i18n.global.t("pages.EditCategoryCard") },
                            { name: i18n.global.t("pages.EditIntegrationFilterCard") },
                            { name: i18n.global.t("pages.CreateIntegrationFilterItemCard") }
                        ]
                    }
                }
            },
            {
                name: 'IntegrationCustomFieldsSettings',
                path: 'orders/settings/custom-fields',
                component: IntegrationCustomFieldsSettings,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.ProductsSettings") },
                            { name: i18n.global.t("pages.IntegrationCustomFieldsSettings") }
                        ]
                    }
                }
            },
            {
                name: 'IntegrationStatusMatrix',
                path: 'orders/settings/status-matrix',
                component: IntegrationStatusMatrix,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.ProductsSettings") },
                            { name: i18n.global.t("pages.IntegrationStatusMatrix") }
                        ]
                    }
                }
            },
            {
                path: `groups/:groupId/copy`,
                name: 'CopyGroupProductsPage',
                component: CopyGroupProductsPage,
                meta: {
                    breadcrumb: () => {
                        return [
                            { name: i18n.global.t("pages.Catalog") },
                            { name: i18n.global.t("pages.ProductsTable") },
                            { name: i18n.global.t("pages.Product") },
                            { name: i18n.global.t("pages.CopyGroupProductsPage") }
                        ]
                    }
                }
            }
        ]
    },
    {
        path: `${basePath}/create`,
        name: "CreateIntegrationPage",
        component: CreateIntegrationPage,
        meta: {
            breadcrumb: () => {
                return [
                    { name: i18n.global.t("pages.IndexIntegrationsPage"), linkName: 'IndexIntegrationsPage' },
                    { name: i18n.global.t("pages.CreateIntegrationPage") }
                ]
            }
        }
    },
]

export default integrationsRoutes
